/**
 *
 * @param url string | undefined
 * @returns Check if the given string is a valid IP address or URL
 */
export default function isIPAddress(url?: string): boolean {
  if (!url) return false;

  const unifiedRegex =
    /^(https?:\/\/)?((([a-zA-Z0-9]+([-.][a-zA-Z0-9]+)*)\.[a-zA-Z]{2,63})|((\d{1,3}\.){3}\d{1,3}))(:\d{1,5})?(\/.*)?$/;

  return unifiedRegex.test(url);
}

// Validate if a string is a valid number
export function isValidNumber(value: string) {
  return !isNaN(Number(value));
}
